import {useEffect,useState} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import pro1 from '../assets/imgs/delight-home.png';
import pro2 from '../assets/imgs/pro-2.png';
import pro3 from '../assets/imgs/pro-3.png';
import pro4 from '../assets/imgs/test-pro1.png';
import pro5 from '../assets/imgs/pro-5.png';
import pro6 from '../assets/imgs/Game1.png';
import pro7 from '../assets/imgs/We8-1.png';
import pro8 from '../assets/imgs/portfolio1.png';
import pro9 from '../assets/imgs/event7.png';
import LoadingButton from './utils/Loading';
import LoadingAction from './utils/LoadingAction';
import LoadingActionWithIndex from './utils/LoadingActionWithIndex';
import { useNavigate } from 'react-router-dom';

const allProject = [
  {
    title: 'EventGlow',
    description: 'Full-stack Smart Event Planner & Budget Optimizer with event management, vendor services, and expense tracking.',
    img: pro9,
    link: 'https://event-glow.netlify.app/',
    category: 'Full Stack',
  },
  {
    title: 'Bakery Website',
    description: 'Modern ReactJS-based bakery website<br/>for sweet and smooth browsing.',
    img: pro1,
    link: 'https://tehzeeb2487.github.io/Delight-Bakery/',
    category: 'Website',
  },
  {
    title: 'Twist Tile Game',
    description: 'A fun and interactive puzzle game<br/>where you twist tiles to solve the image.',
    img: pro6,
    link: 'https://tehzeeb2487.github.io/Twist-Tile-Game/',
    category: 'Game',
  },
  {
    title: 'Ecommerce Dashboard UI',
    description: 'A Responsive E-commerce </br>Dashboard UI build only with HTML and CSS',
    img: pro3,
    link: 'https://tehzeeb2487.github.io/E-commerce-Dashboard-UI/',
    category: 'Dashboard',
  },
  {
    title: 'We8-Grocery',
    description: 'A responsive online grocery store<br/>interface built to simplify product<br/>browsing and ordering',
    img: pro7,
    link: 'https://tehzeeb2487.github.io/We8-Grocery/',
    category: 'Website',
  },
  {
    title: 'Simple JS Calculator',
    description: 'A basic calculator built with<br/>HTML, CSS, and JavaScript.',
    img: pro5,
    link: 'https://tehzeeb2487.github.io/Calculator-repo/',
    category: 'All',
  },
  {
    title: 'Bootstrap 5 UI Demo',
    description: 'A simple, responsive web UI<br/>built only with Bootstrap 5.',
    img: pro4,
    link: 'https://tehzeeb2487.github.io/Bootstrap-5-Testing-project/',
    category: 'Website',
  },
  {
    title: 'ShopMaster',
    description: 'Responsive Bootstrap<br/>E-commerce Dashboard',
    img: pro2,
    link: 'https://tehzeeb2487.github.io/E-commers-order-page/',
    category: 'Dashboard',
  },
  {
    title: 'My Portfolio',
    description: 'A showcase of my projects built with React, JavaScript, HTML, and CSS — from websites and dashboards to games and utilities.',
    img: pro8,
    link: 'https://stj-portfolio.netlify.app',
    category: 'Website',
  },
];

const Project = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [viewAllLoading, setViewAllLoading] = useState(false); 
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  },[]);

  const filteredProjects = activeCategory === 'All' 
    ? allProject.slice(0, 6) 
    : allProject.filter(project => project.category === activeCategory);

  const categories = ['All', 'Website', 'Game', 'Dashboard', 'Full Stack'];

  return (
    <section className="section" id="portfolio">
      <div className="container text-center">
        <p className="section-subtitle" data-aos="fade-up">What I Did ?</p>
        <h6 className="section-title mb-4" data-aos="fade-up">Projects</h6>

        <nav className="pro-nav" data-aos="fade-up">
          <div className='container'>
            <ul className="mb-4 nav justify-content-center">
              {categories.map(category => (
                <li 
                  key={category}
                  className={`item mx-2 ${activeCategory === category ? 'active' : ''}`}
                  onClick={() => setActiveCategory(category)}
                >
                  <a className='link' href='#portfolio'>{category}</a>
                </li>
              ))}
            </ul>
          </div>
        </nav>

        <div className="row">
          {filteredProjects.map((project, index) => {
            return (
            <div className='col-md-4 px-2 mb-3 rounded' key={index}>
              <a href={project.link} target='_blank' className="portfolio-card" rel="noopener noreferrer" data-aos="fade-up">
                <img src={project.img} className="portfolio-card-img rounded" alt={project.title} />
                <span className="portfolio-card-overlay rounded">
                  <span className="portfolio-card-caption">
                    <h4>{project.title}</h4>
                    <p className="font-weight-normal" dangerouslySetInnerHTML={{ __html: project.description }}></p>
                    <LoadingButton 
                      isLoading={loadingIndex === index}
                      onClick={() => 
                        LoadingActionWithIndex(
                          setLoadingIndex,
                          index,
                          () => {
                            const newWindow = window.open(
                              project.link,
                              "_blank", 
                              "noopener,noreferrer"
                            );

                            if (newWindow) {
                              newWindow.opener = null;
                            }
                          }
                        )
                      }
                      className="btn btn-primary rounded-pill px-3 shadow"
                      dotColor='#fff'
                    >
                      Live Demo
                    </LoadingButton>
                  </span>
                </span>
              </a>
            </div>
            );
          })}
        </div>


        <div data-aos="fade-up">
          <LoadingButton
            isLoading={viewAllLoading}
            onClick={() => 
              LoadingAction(
                setViewAllLoading,
                () => navigate("/allProjects")
              )
            }
            className="btn btn-primary rounded-pill px-3 shadow"
          >
            View All Projects
          </LoadingButton>
        </div>

      </div>
    </section>
  );
};

export default Project;
